export default {
  buttons: {
    confirm: 'Bestätigen',
  },
  toasts: {
    invalid_code: 'Ungültiger Code. Bitte versuche es erneut.',
  },
};
